import { createContext, useEffect, useReducer } from "react";
import { userReducer } from "../reducers/userReducer";

// Creating the UserContext to manage user-related state globally
const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  // Initial state for the user, retrieved from localStorage if available
  const initialState = JSON.parse(localStorage.getItem("currentUser")) || {
    username: "",
    fname: "",
    lname: "",
    email: "",
    password: "",
    cart: {
      products: [],
      amount: 0,
      total: 0,
    },
    purchasedProducts: [],
  };

  // useReducer for state management using the userReducer function
  const [userState, dispatch] = useReducer(userReducer, initialState);

  // useEffect to store user data in localStorage whenever userState changes
  useEffect(() => {
    if (userState.username) {
      localStorage.setItem(userState.username, JSON.stringify(userState));
      localStorage.setItem("currentUser", JSON.stringify(userState));
    }
  }, [userState]);

  return (
    // Providing userState and dispatch function to the context consumers
    <UserContext.Provider value={{ userState, dispatch }}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserContextProvider };
